import 'source-map-support/register'
import 'babel-polyfill'